<template>
    <svg aria-hidden="true" focusable="false" width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="19.6818" y="5.35089" width="2.81818" height="2.81818" rx="1.40909" class="stroke fill-active-red" />
        <rect x="2.5" y="5.35089" width="2.81818" height="2.81818" rx="1.40909" class="stroke fill-active-red" />
        <path d="M8.68176 7.23721H16.3181" class="stroke" stroke-linecap="round" />
        <rect x="19.6818" y="22.5327" width="2.81818" height="2.81818" rx="1.40909" class="stroke fill-active-red" />
        <rect x="2.5" y="22.5327" width="2.81818" height="2.81818" rx="1.40909" class="stroke fill-active-red" />
        <path d="M8.68176 24.4191H16.3181" class="stroke" stroke-linecap="round" />
        <path d="M21.0911 11.5327L21.0911 19.1691" class="stroke" stroke-linecap="round" />
        <path d="M3.90912 11.5327L3.90912 19.1691" class="stroke" stroke-linecap="round" />
    </svg>
</template>
